const initialState = {
  vendor: null,
  vendors: [],
  bids: [],
  bidStats: null,
  lastDoc: null,
  hasMore: true,
  isFetching: false,
  isFetchingVendor: false,
  actionLoading: false,
  bidHistory: [],
  substituteRequests: [],
  vendorsForBids: [],
};

const vendorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "REJECTED_SUBSTITUTE_REQUEST":
      return {
        ...state,
        substituteRequests: state.substituteRequests.filter(
          (items) => items.id !== action.payload
        ),
      };
    case "GET_SUBSTITUTE_REQUESTS":
      return {
        ...state,
        substituteRequests: action.payload,
      };
    case "GET_BID_HISTORY":
      return {
        ...state,
        bidHistory: action.payload,
      };
    case "FETCH_VENDOR_BY_ID_PENDING":
      return {
        ...state,
        isFetchingVendor: true,
      };
    case "FETCH_VENDOR_BY_ID_SUCCESS":
      return {
        ...state,
        isFetchingVendor: false,
        vendor: action.payload,
      };
    case "FETCH_VENDOR_BY_ID_REJECTED":
      return {
        ...state,
        isFetchingVendor: false,
      };
    case "FETCH_BIDS_PENDING":
    case "FETCH_VENDORS_PENDING":
      return {
        ...state,
        isFetching: true,
      };
    case "FETCH_VENDORS_SUCCESS_EMPTY":
      return {
        ...state,
        isFetching: false,
        vendors: action.payload.vendors,
        lastDoc: action.payload.lastDoc,
        hasMore: action.payload.hasMore,
      };
    case "FETCH_VENDORS_SUCCESS":
      return {
        ...state,
        isFetching: false,
        vendors: [...state.vendors, ...action.payload.vendors],
        lastDoc: action.payload.lastDoc,
        hasMore: action.payload.hasMore,
      };
    case "FETCH_BIDS_SUCCESS_EMPTY":
      return {
        ...state,
        isFetching: false,
        bids: action.payload.bids,
        lastDoc: action.payload.lastDoc,
        hasMore: action.payload.hasMore,
      };
    case "FETCH_BIDS_SUCCESS":
      return {
        ...state,
        isFetching: false,
        bids: [...state.bids, ...action.payload.bids],
        lastDoc: action.payload.lastDoc,
        hasMore: action.payload.hasMore,
      };
    case "FETCH_BIDS_REJECTED":
    case "FETCH_VENDORS_REJECTED":
      return {
        ...state,
        isFetching: false,
      };
    case "FETCH_BIDS_STATS_SUCCESS":
      return {
        ...state,
        bidStats: action.payload,
      };
    case "BID_ACTION_PENDING":
    case "VENDOR_ACTION_PENDING":
      return {
        ...state,
        actionLoading: true,
      };
    case "VENDOR_ACTION_SUCCESS":
      return {
        ...state,
        actionLoading: false,
        vendors: state.vendors.filter(
          (vendor) => vendor.id !== action.payload.vendorId
        ),
      };
    case "BID_ACTION_SUCCESS":
      const { bidId, status, statusOrder, reason } = action.payload;
      const filteredBids = state.bids.filter((bid) => bid.id !== bidId);
      const updatedBid = {
        ...state.bids.find((bid) => bid.id === bidId),
        status,
        issue: reason || state.bids.find((bid) => bid.id === bidId)?.issue,
        statusOrder,
      };
      let insertionIndex = filteredBids.findIndex(
        (bid) => bid.statusOrder > statusOrder
      );
      if (insertionIndex === -1) {
        insertionIndex = filteredBids.length;
      }
      const updatedBids = [
        ...filteredBids.slice(0, insertionIndex),
        updatedBid,
        ...filteredBids.slice(insertionIndex),
      ];

      return {
        ...state,
        bids: updatedBids,
        actionLoading: false,
      };
    case "BID_ACTION_REJECTED":
    case "VENDOR_ACTION_REJECTED":
      return {
        ...state,
        actionLoading: false,
      };
    case "REJECT_VENDOR_SUCCESS":
      return {
        ...state,
        actionLoading: false,
        vendors: state.bids.filter((vendor) => vendor.id !== action.payload),
      };
    case "REJECT_BID_SUCCESS":
      return {
        ...state,
        actionLoading: false,
        bids: state.bids.filter((bid) => bid.id !== action.payload),
      };
    case "FETCH_VENDORS_FOR_BIDS":
      return {
        ...state,
        vendorsForBids: action.payload,
      };
    default:
      return state;
  }
};

export default vendorsReducer;
